import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CollectionForm } from "@univdiam/ui/customComponents/CollectionList/CollectionForm";
import api from "@/http/api";

export default function CollectionEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const response = await api.get(`/api/collection/${id}`);
        if (response.status === 200 && response.data) {
          const group = response.data.data;
          console.log(group);
          // Map fields to your form shape
          setInitialData({
            group_id: group.group_id,
            name: group.name,
            code: group.code,
            status: group.status === 1 ? "1" : "0",
          });
        }
      } catch (err) {
        console.error("Failed to fetch group", err);
        alert("Error fetching group.");
        navigate("/collection");
      }
    };

    fetchCollection();
  }, [id, navigate]);

  const handleUpdateCollection = async (data: any) => {
    try {
      const response = await api.put(`/api/collection/${id}`, data);
      if (response.status === 200) {
        alert("Collection updated successfully!");
        navigate("/collection");
      }
    } catch (error) {
      console.error("Error updating Collection:", error);
      alert("Failed to update Collection.");
    }
  };

  if (!initialData) return <p className="text-center p-10">Loading...</p>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit Group</h1>
      <CollectionForm
        onSubmit={handleUpdateCollection}
        initialValues={initialData}
        isEdit
      />
    </div>
  );
}
